import type { NavigationLike } from './navigation-polyfill'

export function useNativeNavigation(_navigation: NavigationLike): void {}
